export const tipData = [{
  1: {
    1: '阅读建议用时：10分钟',
    2: '恭喜你已完成阅读部分，听力建议用时：10分钟',
    3: '恭喜你已完成听力部分，口语建议用时：2分钟',
    4: '恭喜你已完成口语部分，写作建议用时：8分钟',
  },
  2: {
    1: '听力建议用时：7分钟',
    2: '恭喜你已完成听力部分，阅读建议用时：10分钟',
    3: '恭喜你已完成阅读部分，口语建议用时：5分钟',
    4: '恭喜你已完成口语部分，写作建议用时：8分钟',
  },
}, {}, {
  2: {
    1: '综合部分建议用时：20分钟',
  },
}];
export const suggestTime = {
  1: [10, 30, 40, 40, 15, 40, 10],
  2: [10, 30, 40, 40, 40, 15, 10],
  56: [10, 15, 15, 15],
};

export const sectionIds = {
  1: ['词汇', '语法', '阅读', '听力', '口语', '写作'],
  2: ['词汇', '语法', '听力', '阅读', '写作', '口语'],
  56: ['单项选择', '完形填空', '阅读理解', '数学'],
};



// WEBPACK FOOTER //
// ./src/components/header/constants.js